<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div
          id="dmv"
          class="container-fluid menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <iframe
            :src="page"
            width="100%"
            height="980px"
            id="receiver"
            style="position:relative;z-index:0"
            name="myIframe"
            v-on:load="onLoadIframe"
          ></iframe>
        </div>
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
export default {
  components: { MainMenu, TopHeader, BottomFooter },
  name: 'DMVTitle',

  data () {
    return {
      page: '',
      employeeId: this.$session.get('user_id'),
      userRole: this.$session.get('user_role_name'),
      jwtToken: this.$session.get('JWT'),
      userName: this.$session.get('user_name')
    }
  },
  methods: {
    onLoadIframe () {
      // console.log(this.employeeId)
      // console.log(this.userRole)
      sessionStorage.setItem('getUser', this.employeeId)
      sessionStorage.setItem('getUserRole', this.userRole)
      sessionStorage.setItem('getJwt', this.jwtToken)
      sessionStorage.setItem('getuserName', this.userName)
      var loginInfo = {
        userId: sessionStorage.getItem('getUser'),
        role: sessionStorage.getItem('getUserRole'),
        jwt: sessionStorage.getItem('JWT'),
        userName: sessionStorage.getItem('USERNAME')
      }
      var receiverWindow = document.getElementById('receiver').contentWindow
      receiverWindow.postMessage(loginInfo, this.page)
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#reporting').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },

    readTextFile (file) {
      // read external properties file
      var allText
      var rawFile = new XMLHttpRequest()
      rawFile.open('GET', file, false)
      rawFile.onreadystatechange = function () {
        if (rawFile.readyState === 4) {
          if (rawFile.status === 200 || rawFile.status == 0) {
            allText = rawFile.responseText
            console.log(allText)
          }
        }
      }
      rawFile.send(null)
      return allText
    }
  },
  mounted () {
    this.myFunction()
    this.menuheight()
  },
  created () {
    this.page = this.readTextFile('./dmvlink.txt')
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  }
}
</script>
